import Image from "next/image";


interface StrengthsCardProps {
    title: string;
    description: string;
    imageUrl: string;
    icon: string;
}

export const StrengthsCard = ({ title, description, imageUrl, icon }: StrengthsCardProps) => {
    return (
        <div className="relative flex flex-col rounded-lg border border-gray-200 bg-gray-50 p-6 shadow-sm">

            <div className="flex flex-col gap-6">
                <div className="flex h-16 w-16 items-center justify-center rounded-full border border-gray-200 bg-white text-5xl">
                    <Image
                        src={icon}
                        alt={title}
                        width={30}
                        height={30}
                        className="rounded-xl object-cover"
                    />
                </div>
                <div className="relative">
                    <div className="relative">
                        <Image
                            src={imageUrl}
                            alt={title}
                            width={268}
                            height={104}
                            className="w-full rounded-lg object-cover"
                        />
                        <div className="absolute bottom-3 left-3 rounded-md bg-black/60 px-3 py-2 text-sm font-semibold text-white backdrop-blur-sm md:text-base">
                            {title}
                        </div>
                    </div>

                </div>

            </div>

            <div className="flex flex-col mt-3">
                <p className="mt-2 text-center text-base text-gray-600 md:text-lg">{description}</p>
            </div>


        </div>

    )
}

export default StrengthsCard;
